import { useTenant } from "../../../tenant/branding/useTenant";
import styles from "./BpsAdminDashboard.module.scss";

// Landing page of the BPS admin portal, shown straight after login instead of the
// module picker at /bps/admin/home. Placeholder content — the chrome (sidebar,
// header) and the real widgets land with the layout work.
export const BpsAdminDashboard = () => {
	const { name } = useTenant();

	return (
		<div className={styles.container}>
			<h1 className={styles.title}>{name}</h1>
			<p className={styles.subtitle}>Dashboard</p>
		</div>
	);
};
